exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-container .loading[_v-151e71cc]{padding:15px}.loading-container .spinner svg[_v-151e71cc]{width:28px;height:28px;stroke:#fff;fill:#fff}.loading-container .tips[_v-151e71cc]{font-size:14px;line-height:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-151e71cc&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/loading/Loading.vue
// module id = 181
// module chunks = 0